import styled from "styled-components";
import { THEME } from "../../styles/theme";

export const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: linear-gradient(
    180deg,
    ${THEME.palette.background.default} 60%,
    transparent 60%
  );
`;
export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 2rem;
`;

export const PromotionsContainer = styled.div`
  padding: 3rem 2rem 0 2rem;
  margin-top: -4rem;
  border-radius: 2rem 2rem 0 0;
  background-color: ${THEME.palette.background.paper};
  height: 100%;
`;

export const PromotionsList = styled.div`
  padding: 1rem 0;
  display: grid;
  gap: 1rem;
`;
